import $ from "jquery";
import "slick-carousel";


const testSlider = 'home-reviews-slider';
const $currentSlide = $(`.controls-current-${testSlider}`);

if ($currentSlide) {
  $currentSlide.text('1/' + $('.home-reviews .review').length );
}

$(`.${testSlider}`).on("init beforeChange", function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find("li");
    const theme = $(`.controls-dots-${testSlider}`).data("theme");
    if (theme) {
      dots.addClass('slick-dot ' + theme);
    }
  }
});


$(`.${testSlider}`).slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  appendDots: $(`.controls-dots-${testSlider}`),
  nextArrow: $(`.controls-next-${testSlider}`),
  prevArrow: $(`.controls-prev-${testSlider}`),
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8%',
      },
    },
  ],
});

$(`.${testSlider}`).on('init reInit afterChange', function (event, slick, currentSlide) {
  const current = (currentSlide ? currentSlide : 0) + 1;
  if ($currentSlide) {
    $currentSlide.text(current + '/' + slick.slideCount);
  }
});